import type { JSX } from 'react';

import { useCachedData } from 'Components/Context/CachedDataContext';
import { Text } from 'Components/Text/Text';
import { iso8601ToUsTimestampLong } from 'Helpers/DateTimeUtils/DateTimeUtils';
import { getUserNameFromSubject } from 'Helpers/UserUtils';
import { Comment } from 'Models/OperationalControls';

import styles from '../ConductAssessment.module.css';

export interface CurrentAssessmentOwnerCommentHistoryProps {
    handleRequestError: (error: Error) => void;
    ownerCommentHistory?: Comment[];
}

export const CurrentAssessmentOwnerCommentHistory = (props: CurrentAssessmentOwnerCommentHistoryProps): JSX.Element => {
    return (
        <div className={styles.fullWidth}>
            <Text variant="Header2">Comment History</Text>
            <hr />
            <OwnerCommentHistory commentHistory={props.ownerCommentHistory} />
        </div>
    );
};

interface OwnerCommentHistoryProps {
    commentHistory?: Comment[];
}
const OwnerCommentHistory = (props: OwnerCommentHistoryProps): JSX.Element | null => {
    const cachedData = useCachedData();

    if (!props.commentHistory || props.commentHistory.length < 1) {
        return null;
    } else {
        return (
            <div className={styles.alignVertical}>
                {[...props.commentHistory].sort(compareComments).map((comment, index) => {
                    return (
                        <div className={styles.ownerCommentHistoryContainer} key={index}>
                            <div className={styles.ownerCommentHistoryUserAndTimestamp}>
                                <Text>{comment.user_id ? getUserNameFromSubject(comment.user_id, cachedData.users) : ''}</Text>
                                <Text>{comment.timestamp ? iso8601ToUsTimestampLong(comment.timestamp) : ''}</Text>
                            </div>
                            <Text>{comment.text}</Text>
                        </div>
                    );
                })}
            </div>
        );
    }
};

const compareComments = (a: Comment, b: Comment): number => {
    if (a.timestamp && b.timestamp) {
        return a.timestamp < b.timestamp ? 1 : -1;
    } else {
        return 0;
    }
};
